<template>
  <div class="flex">
    <ul
      ref="tabHeader"
      class="flex-1 tab-header list-reset flex no-scrollbar overflow-x-scroll"
    >
      <li
        v-for="(region, index) in regions"
        :key="region.id"
        class="mx-4 my-8 font-medium flex-none whitespace-no-wrap cursor-pointer"
        :class="{ selected: index === selectedIndex }"
      >
        <span class="widen-click-area-10px" @click="updateIndex(index)">
          {{ region.name }}
        </span>
      </li>
    </ul>
    <div class="flex-none my-8 ml-4" v-if="isShowingNavigations">
      <button type="button" @click="scrollTabLeft">
        <svg width="24" height="24">
          <use xlink:href="/img/sprite.svg#ic_chevron-left"></use>
        </svg>
      </button>
      <button type="button" @click="scrollTabRight">
        <svg width="24" height="24">
          <use xlink:href="/img/sprite.svg#ic_chevron-right"></use>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["countryStructure", "selectedIndex"],
  data() {
    return {
      isShowingNavigations: true,
    };
  },
  computed: {
    regions() {
      return this.countryStructure.children.filter((region) => {
        return Boolean(region.children.length);
      });
    },
  },
  methods: {
    updateIndex(index) {
      this.$emit("update:selectedIndex", index);
    },
    scrollTabRight() {
      $(this.$refs.tabHeader).animate(
        {
          scrollLeft: this.$refs.tabHeader.scrollLeft + 200,
        },
        200
      );
    },
    scrollTabLeft() {
      $(this.$refs.tabHeader).animate(
        {
          scrollLeft: this.$refs.tabHeader.scrollLeft - 200,
        },
        200
      );
    },
  },
  mounted() {
    if (this.$refs.tabHeader) {
      const clientWidth = this.$refs.tabHeader.clientWidth;
      const scrollWidth = this.$refs.tabHeader.scrollWidth;

      if (scrollWidth > clientWidth) {
        this.isShowingNavigations = true;
      } else {
        this.isShowingNavigations = false;
      }
    }
  },
};
</script>

<style scoped>
.tab-header {
  border-bottom: 1px solid var(--border-primary);
}

.selected {
  color: var(--secondary);
  position: relative;
}

.selected::after {
  content: "";
  position: absolute;
  height: 3px;
  left: -12px;
  right: -12px;
  bottom: -32px;
  background-color: var(--secondary);
}
</style>
